import { FeedbackArea } from '../config/schema/FeedbackAreas';
import { getFeedbackAreasForSelection } from './getFeedbackAreasForSelection';

export function getEmailAddresses(): string[] {
    const emails = getFeedbackAreasForSelection().reduce((result: string[], area: FeedbackArea) => {
        return result.concat(area.emailAddresses);
    }, []);
    if (emails.length <= 0) {
        emails.push('owareactmail@service.microsoft.com');
    }
    return emails;
}
